import { format, isBefore, parse, startOfToday } from 'date-fns';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import ChatReportDialog from '../src/components/Common/AlertDialog/ChatReportDialog';
import { getProfileId } from './authUtils';
import { CHAT_NOTIFICATION_TYPES } from './constant';
import { getLocale, getLocaleString } from './cityUtils';
const MySwal = withReactContent(Swal);

export function showChatBlockWarning(lang, msg, type, value) {
  return MySwal.fire({
    title: <ChatReportDialog lang={lang} msg={msg} type={type} value={value} />,
    text: '',
    icon: '',
    iconColor: '#000',
    showCancelButton: true,
    confirmButtonColor: '#000',
    confirmButtonText: lang?.market?.yes,
    cancelButtonText: lang?.common?.cancel,
    customClass: {
      actions: '',
      cancelButton: 'order-1',
      confirmButton: 'order-2',
      title: 'title-style',
      closeButton: 'close-button-swal',
    },
  });
}

export function formatChatDate(date, cityId = 1) {
  // Use an ISO 8601-compliant parser for better compatibility
  const parsedDate =
    typeof date === 'string'
      ? new Date(date.replace(/-/g, '/'))
      : new Date(date);

  // Validate the date object
  if (isNaN(parsedDate.getTime())) {
    return 'Invalid date';
  }

  // Get the current time and today's start
  const now = new Date();
  const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate());

  // Choose formatting options based on whether the date is today
  if (parsedDate < todayStart) {
    return new Intl.DateTimeFormat(getLocaleString(cityId), {
      month: 'long',
      day: 'numeric',
    }).format(parsedDate);
  } else {
    return new Intl.DateTimeFormat(getLocaleString(cityId), {
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,
    }).format(parsedDate);
  }
}

export function showOnlyMessageTime(date) {
  const todayStart = startOfToday();
  if (isBefore(date, todayStart)) {
    return true;
  } else return false;
}

export const formatCustomDate = (date, cityId, lang) => {
  if (date instanceof Date && !isNaN(date.getTime())) {
    const now = new Date();
    const isToday = date.toDateString() === now.toDateString();
    const isYesterday =
      date.toDateString() ===
      new Date(now.setDate(now.getDate() - 1)).toDateString();

    // const hours = date.getHours();
    // const minutes = date.getMinutes();
    // const meridiem = hours >= 12 ? 'PM' : 'AM';
    // const formattedHours = hours % 12 || 12; // Convert to 12-hour format
    // const formattedMinutes = minutes.toString().padStart(2, '0'); // Ensure two-digit minutes

    if (isToday) {
      // return `Today ${formattedHours}:${formattedMinutes} ${meridiem}`;
      return lang?.common?.today || 'Today';
    } else if (isYesterday) {
      return lang?.common?.yesterday || 'Yesterday';
    } else {
      const formattedDate = format(date, 'MMMM do', {
        locale: getLocale(cityId),
      });
      // return `${formattedDate} ${formattedHours}:${formattedMinutes} ${meridiem}`;
      return formattedDate;
    }
  } else {
    return;
  }
};

export function isSameDate(date1, date2) {
  // Extract the year, month, and day from both dates
  const d1Year = date1.getFullYear();
  const d1Month = date1.getMonth();
  const d1Day = date1.getDate();

  const d2Year = date2.getFullYear();
  const d2Month = date2.getMonth();
  const d2Day = date2.getDate();

  // Compare the extracted values
  return d1Year === d2Year && d1Month === d2Month && d1Day === d2Day;
}

export function isSameTime(date1, date2) {
  // Extract the hours and minutes from both dates
  const d1Hours = date1.getHours();
  const d1Minutes = date1.getMinutes();

  const d2Hours = date2.getHours();
  const d2Minutes = date2.getMinutes();

  // Compare the extracted values
  return d1Hours === d2Hours && d1Minutes === d2Minutes;
}

export function hasChatNotification(unreadNotifications) {
  if (unreadNotifications && unreadNotifications?.length > 0) {
    for (const item of unreadNotifications) {
      if (CHAT_NOTIFICATION_TYPES.includes(item?.notification_type)) {
        return true;
      }
    }
  }

  return false;
}

export function hasOnlyChatNotification(unreadNotifications) {
  if (unreadNotifications && unreadNotifications?.length > 0) {
    const filteredNotifications = unreadNotifications.filter((item) =>
      CHAT_NOTIFICATION_TYPES.includes(item?.notification_type)
    );

    if (
      filteredNotifications &&
      filteredNotifications.length === unreadNotifications.length
    ) {
      return true;
    }
  }

  return false;
}

export function isOnlyNewlines(text) {
  return /^\n*$/.test(text);
}

export const isChatReceiver = (receiverProfileId) => {
  return receiverProfileId == getProfileId();
};

export function formattedChatTime(chatTime) {
  if (chatTime) {
    const inputFormat = 'yyyy-MM-dd h:mm a';

    const parsedDate = parse(chatTime, inputFormat, new Date());

    const formattedTime = format(parsedDate, 'hh:mm a');

    return formattedTime;
  }

  return '';
}
